import pregnancyTrimester1 from '@/data/paid/pregnancy-trimester-1.json';
import pregnancyTrimester2 from '@/data/paid/pregnancy-trimester-2.json';
import pregnancyTrimester3 from '@/data/paid/pregnancy-trimester-3.json';

/** Реестр комплексных услуг: parentServiceId → состав из data/paid/*.json */
const PACKAGES = [pregnancyTrimester1, pregnancyTrimester2, pregnancyTrimester3];

const byParentId = Object.create(null);
const byParentName = Object.create(null);

PACKAGES.forEach((pkg) => {
  if (!pkg) return;
  const id = pkg.parentServiceId != null ? String(pkg.parentServiceId).trim() : '';
  const name = pkg.parentServiceName != null ? String(pkg.parentServiceName).trim() : '';
  if (id) byParentId[id] = pkg;
  if (name) byParentName[name] = pkg;
});

function buildPriceIndex(paidGroups) {
  const byId = Object.create(null);
  (paidGroups || []).forEach((group) => {
    (group.services || []).forEach((svc) => {
      const id = svc && svc.id != null ? String(svc.id).trim() : '';
      if (id) byId[id] = svc;
    });
  });
  return byId;
}

/**
 * Пакет состава для услуги прайса (если есть).
 * @param {{ id?: string, name?: string }|null} service
 * @returns {object|null}
 */
export function getPaidPackage(service) {
  if (!service) return null;
  const id = service.id != null ? String(service.id).trim() : '';
  if (id && byParentId[id]) return byParentId[id];
  const name = service.name != null ? String(service.name).trim() : '';
  if (name && byParentName[name]) return byParentName[name];
  return null;
}

/**
 * Состав пакета с актуальными ценами/названиями из /sections.
 * Цена берётся из API по id позиции; если id не найден — price: null.
 */
export function resolvePaidPackageItems(service, paidGroups) {
  const pkg = getPaidPackage(service);
  if (!pkg) return [];
  const byId = buildPriceIndex(paidGroups);
  return (pkg.items || []).map((item, index) => {
    const id = item && item.id != null ? String(item.id).trim() : '';
    const hit = id ? byId[id] : null;
    const quantity = item && item.quantity != null ? Number(item.quantity) || 1 : 1;
    return {
      key: id || `pkg-item-${index}`,
      id,
      name: (hit && hit.name) || (item && item.name) || '',
      quantity,
      price: hit && hit.price != null ? hit.price : null,
    };
  });
}
